var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: { animation: "slide", open: _vm.isOpen, "data-cy": "gops-data" },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "header",
                {
                  staticClass: "card-header",
                  attrs: { role: "banner", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" Información financiera "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("section", { staticClass: "card-block p-0 pt-1 pb-1" }, [
        _c(
          "div",
          { staticClass: "subcard is-gray" },
          [
            _c(
              "b-field",
              {
                staticClass: "has-addons",
                attrs: { label: "Renta promedio", horizontal: "" },
              },
              [
                _c(
                  "div",
                  { staticClass: "field has-addons" },
                  [
                    _c("p", { staticClass: "control" }, [
                      _c("a", { staticClass: "button is-static" }, [
                        _vm._v("CLP"),
                      ]),
                    ]),
                    _c("b-input", {
                      staticClass: "pr-2",
                      attrs: {
                        value: _vm.formatNumberByCountry(
                          _vm.simulation.offerInputs.disposableIncome
                        ),
                        disabled: _vm.readOnly,
                        size: "is-small",
                        type: _vm.readOnly ? "string" : "number",
                        placeholder: "Ingresa valor en UF",
                        expanded: "",
                      },
                    }),
                    _c("b-button", {
                      staticClass: "header-icon",
                      attrs: {
                        size: "is-small",
                        "data-cy": "propertiesAverageIncome",
                        "icon-left": _vm.propertiesAverageIncome
                          ? "angle-down"
                          : "angle-right",
                      },
                      on: { click: _vm.togglePropertiesAverageIncome },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm.propertiesAverageIncome
              ? _c(
                  "div",
                  { staticClass: "fields-has-text-right" },
                  [
                    _c(
                      "b-field",
                      { staticClass: "has-addons", attrs: { horizontal: "" } },
                      [
                        _c("div", { staticClass: "field has-addons" }, [
                          _c(
                            "small",
                            { staticClass: "has-text-grey-light subtitle" },
                            [_vm._v("Deudor")]
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Dependiente", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("CLP"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                value: _vm.formatNumberByCountry(
                                  _vm.simulation.offerInputs.disposableIncome
                                ),
                                disabled: _vm.readOnly,
                                size: "is-small",
                                type: _vm.readOnly ? "string" : "number",
                                placeholder: "Ingresa valor en UF",
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "has-addons",
                        attrs: { label: "Independiente", horizontal: "" },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "field has-addons" },
                          [
                            _c("p", { staticClass: "control" }, [
                              _c("a", { staticClass: "button is-static" }, [
                                _vm._v("CLP"),
                              ]),
                            ]),
                            _c("b-input", {
                              attrs: {
                                disabled: _vm.readOnly,
                                value: "0",
                                size: "is-small",
                                type: "number",
                                placeholder: "Ingresa valor en UF",
                                expanded: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Deuda mensual"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.propertiesMonthlyDebt
                    ? "angle-up"
                    : "angle-down",
                },
                on: { click: _vm.togglePropertiesMonthlyDebt },
              }),
            ],
            1
          ),
          _vm.propertiesMonthlyDebt
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c(
                    "b-field",
                    {
                      staticClass: "has-addons",
                      attrs: { label: " ", horizontal: "" },
                    },
                    [
                      _c("div", { staticClass: "field has-addons" }, [
                        _c(
                          "small",
                          { staticClass: "has-text-grey-light subtitle" },
                          [_vm._v("Deudor")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "has-addons",
                      attrs: { label: "Corto plazo", horizontal: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field has-addons" },
                        [
                          _c("p", { staticClass: "control" }, [
                            _c("a", { staticClass: "button is-static" }, [
                              _vm._v("CLP"),
                            ]),
                          ]),
                          _c("b-input", {
                            attrs: {
                              value: _vm.formatNumberByCountry(
                                _vm.simulation.offerInputs.shortTermMonthlyFee
                              ),
                              disabled: _vm.readOnly,
                              size: "is-small",
                              type: _vm.readOnly ? "string" : "number",
                              placeholder: "Ingresa valor en UF",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-field",
                    {
                      staticClass: "has-addons",
                      attrs: { label: "Largo plazo", horizontal: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "field has-addons" },
                        [
                          _c("p", { staticClass: "control" }, [
                            _c("a", { staticClass: "button is-static" }, [
                              _vm._v("CLP"),
                            ]),
                          ]),
                          _c("b-input", {
                            attrs: {
                              value: _vm.formatNumberByCountry(
                                _vm.simulation.offerInputs.longTermMonthlyFee
                              ),
                              disabled: _vm.readOnly,
                              size: "is-small",
                              type: _vm.readOnly ? "string" : "number",
                              placeholder: "Ingresa valor en UF",
                              expanded: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm.eligibilityData
          ? _c("div", { staticClass: "subcard is-gray" }, [
              _c(
                "div",
                { staticClass: "subcard-header" },
                [
                  _c("p", { staticClass: "header-title" }, [
                    _vm._v("Elegibilidad"),
                  ]),
                  _c("b-button", {
                    staticClass: "header-icon",
                    attrs: {
                      size: "is-small",
                      "icon-left": _vm.propertiesEligibility
                        ? "angle-up"
                        : "angle-down",
                    },
                    on: { click: _vm.togglePropertiesEligibility },
                  }),
                ],
                1
              ),
              _vm.propertiesEligibility
                ? _c(
                    "div",
                    { staticClass: "subcard-content fields-has-text-right" },
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "Tipo", horizontal: "" } },
                        [
                          _c(
                            "b-select",
                            {
                              attrs: {
                                disabled: _vm.readOnly,
                                size: "is-small",
                                placeholder: "Selecciona un tipo",
                                expanded: "",
                              },
                              model: {
                                value: _vm.evaluationEligibility,
                                callback: function ($$v) {
                                  _vm.evaluationEligibility = $$v
                                },
                                expression: "evaluationEligibility",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "Approved" } }, [
                                _vm._v("Aprobado"),
                              ]),
                              _c("option", { attrs: { value: "Reviewable" } }, [
                                _vm._v("Revisión"),
                              ]),
                              _c("option", { attrs: { value: "Refused" } }, [
                                _vm._v("Rechazado"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          staticClass: "has-addons",
                          attrs: { horizontal: "" },
                        },
                        [
                          _c("div", { staticClass: "field has-addons" }, [
                            _c(
                              "small",
                              { staticClass: "has-text-grey-light subtitle" },
                              [_vm._v("Deudor")]
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Edad", horizontal: "" } },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data": _vm.eligibilityDataProps.age,
                              "eligibility-param": _vm.eligibilityParams.age,
                              print: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Nacionalidad", horizontal: "" } },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.nationality,
                              "eligibility-param":
                                _vm.eligibilityParams.nationality,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Residencia", horizontal: "" } },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.residence,
                              "eligibility-param":
                                _vm.eligibilityParams.residence,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "PEP", horizontal: "" } },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.publicExposedPerson,
                              "eligibility-param":
                                _vm.eligibilityParams.publicExposedPerson,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Lista negra externa",
                            horizontal: "",
                          },
                        },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.blackListExternal,
                              "eligibility-param":
                                _vm.eligibilityParams.blackListExternal,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Lista negra interna",
                            horizontal: "",
                          },
                        },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.blackListInternal,
                              "eligibility-param":
                                _vm.eligibilityParams.blackListInternal,
                            },
                          }),
                        ],
                        1
                      ),
                      _c("section", { staticClass: "job-continuity" }, [
                        _c(
                          "div",
                          { staticClass: "collapse-inner text-center" },
                          [
                            _c("p", { staticClass: "card-header-title" }, [
                              _vm._v(" Continuidad laboral "),
                            ]),
                          ]
                        ),
                        _c(
                          "article",
                          { staticClass: "fields-has-text-right" },
                          [
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: "Dependiente",
                                  horizontal: "",
                                  "custom-class": "has-text-grey",
                                },
                              },
                              [
                                _c("EligibilityTag", {
                                  attrs: {
                                    "eligibility-data":
                                      _vm.eligibilityDataProps.jobContinuity,
                                    "eligibility-param":
                                      _vm.eligibilityParams.jobContinuity,
                                    inverse: true,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-field",
                              {
                                attrs: {
                                  label: "Independiente",
                                  horizontal: "",
                                  "custom-class": "has-text-grey",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "field is-flex is-justify-content-space-between",
                                  },
                                  [_vm._v("--")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "b-field",
                        {
                          attrs: {
                            label: "Antigüedad laboral",
                            horizontal: "",
                          },
                        },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.jobSeniority,
                              "eligibility-param":
                                _vm.eligibilityParams.jobSeniority,
                              inverse: true,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        {
                          attrs: { label: "Causas judiciales", horizontal: "" },
                        },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.lawsuit,
                              "eligibility-param":
                                _vm.eligibilityParams.lawsuit,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "Nivel de mora", horizontal: "" } },
                        [
                          _c("EligibilityTag", {
                            attrs: {
                              "eligibility-data":
                                _vm.eligibilityDataProps.defaultRate,
                              "eligibility-param":
                                _vm.eligibilityParams.defaultRate,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }